import deviceSlice from './../reducers/device'
import loadControllSlice from './../reducers/loading'
import projectControll from './../reducers/project'
import walletSlice from './../reducers/wallet'
import sideSlice from './../reducers/side'
import userSlice from './../reducers/user'
import accessHistory from './../reducers/accessHistory'

export const resize = deviceSlice.actions.resize
export const connectWallet = walletSlice.actions.connectWallet
export const switchLoding = loadControllSlice.actions.setLoading
export const changeProject = projectControll.actions.setProject
export const changeTrxs = projectControll.actions.setTrxs
export const changeIsStarted = projectControll.actions.setIsStarted
export const changeRpc = projectControll.actions.setRpc
export const changeFeeType = projectControll.actions.setFeeType
export const changeFees = projectControll.actions.setFees
export const changeExtraFloat = projectControll.actions.setExtraFloat
export const changeTransferDone = projectControll.actions.setTransferDone
export const toggleSide = sideSlice.actions.toggleSide
export const login = userSlice.actions.login
export const loadBalance = userSlice.actions.loadBalance
export const accessRouteEdit = accessHistory.actions.accessRouteEdit;
export const accessHistoryAdd = accessHistory.actions.accessHistoryAdd
export const accessHistoryEdit = accessHistory.actions.accessHistoryEdit
export const accessHistoryRemove = accessHistory.actions.accessHistoryRemove
export const accessHistoryClear = accessHistory.actions.accessHistoryClear